import {
    Box,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core'
import React from 'react'


export default function PastCropDetailsComponent({ data }) {
    const monthArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    return (
        <Card>
            <CardContent>
                <Typography style={{ fontWeight: 'bold', color: 'gray', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >Crop Supply History (Kg)</Typography>
                <TableContainer>
                    <Table aria-label="caption table">
                        <TableHead>
                            <TableRow>
                                <TableCell align={'center'}>Month</TableCell>
                                <TableCell align={'center'}>Jan</TableCell>
                                <TableCell align={'center'}>Feb</TableCell>
                                <TableCell align={'center'}>Mar</TableCell>
                                <TableCell align={'center'}>Apr</TableCell>
                                <TableCell align={'center'}>May</TableCell>
                                <TableCell align={'center'}>Jun</TableCell>
                                <TableCell align={'center'}>Jul</TableCell>
                                <TableCell align={'center'}>Aug</TableCell>
                                <TableCell align={'center'}>Sep</TableCell>
                                <TableCell align={'center'}>Oct</TableCell>
                                <TableCell align={'center'}>Nov</TableCell>
                                <TableCell align={'center'}>Dec</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableRow >
                            <TableCell style={{ fontWeight: 'bold', borderBottom: 'none' }} align={'center'}>Total(kg)</TableCell>
                            {monthArray.map((item) => {
                                if (data) {
                                    var res = data.find(x => x.cropCollectedMonth == item)
                                    if (res) {
                                        return (
                                            <TableCell style={{ borderBottom: 'none' }} align={'center'}>{res.totalCollectedCropWeight.toFixed(2)}</TableCell>
                                        )
                                    }
                                    else {
                                        return (
                                            <TableCell style={{ borderBottom: 'none' }} align={'center'}>-</TableCell>
                                        )
                                    }
                                }
                            })}
                        </TableRow>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}
